import React, { useContext } from "react"
import { PCViewContext } from "../PCViewContext"
import Navbar from "react-bootstrap/Navbar"

import locoguideLogo from "../../../images/lamp/logo.png"
import * as styles from "../Styles/Header.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const Header: React.FC<{ logo: string }> = ({ logo }) => {
  const isPC = useContext(PCViewContext)

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={cn("header", isPC ? "pc" : "sp")}
    >
      <Navbar.Brand
        className={styles.logo}
        as="div"
        style={{ display: "flex", alignItems: "baseline" }}
      >
        {logo && <img src={logo} />}
        <div
          className={styles.locoguide}
          style={{ fontSize: "10px", color: "#c6c6c6" }}
        >
          <span style={{ verticalAlign: "middle" }}>Supported by</span>
          <img src={locoguideLogo} alt="ロコガイド" style={{ width: "54px" }} />
        </div>
      </Navbar.Brand>
    </Navbar>
  )
}
export default Header
